export default "__VITE_ASSET__Cu77tmEb__"